import type { FilterOption } from '@/scopes/search/types'
import { useDepartureDateStore } from '@/infrastructure/departure-date/useDepartureDateStore'
import { useIntl } from '@/intl'
import * as TransportTypeFilterPrimitive from '@/scopes/common/components/Filters/TransportTypeFilterPrimitive'
import { Filter } from '@/scopes/search/components/QuickSearchBar/Filter'

import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBar/store'
import * as React from 'react'

export function TransportTypeFilterComponent({
  disabled,
  onConfirm,
  options,
  selectedOption,
  id,
  asSheet,
  biggerBreakpoint,
  ...rest
}: {
  id: string
  asSheet?: boolean
  disabled?: boolean
  onConfirm: (selection: string) => void
  options: FilterOption<string>[]
  selectedOption: string | undefined
  biggerBreakpoint?: boolean
}) {
  const intl = useIntl()
  const { setActiveItem } = useQuickSearchStore()
  const { reset } = useDepartureDateStore()

  const handleFilterChange = (selection: string) => {
    reset()
    onConfirm(selection)
    setActiveItem(null)
  }

  const handleClose = () => {
    setActiveItem(null)
  }

  const formattedText = options.find(option => option.value === selectedOption)?.name || ''

  return (
    <Filter
      id={id}
      placeholder={intl.formatMessage({
        id: 'transport_type_options_label',
      })}
      title={intl.formatMessage({
        id: 'transport_type_label',
      })}
      onConfirm={handleClose}
      selectionFormattedText={formattedText}
      asSheet={asSheet}
      hasPadding
      biggerBreakpoint={biggerBreakpoint}
      data-qa="transport-type-filter"
      autoFocus
      {...rest}
    >
      <TransportTypeFilterPrimitive.Root
        onSelectedValueChange={handleFilterChange}
        selectedOption={selectedOption}
        options={options}
        disabled={disabled}
      />
    </Filter>

  )
}
